import React, {useEffect, useState} from "react";
import PageTitle from "../../Utils/smsTitle";
import {SubHeader} from "../../../Containers/SubHeader";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {EnhancedSearchTableToolbar, CustomTablePagination} from "../../Utils/Tables/CustomTable";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import * as snackbarActions from "../../../actions/snackbarActions";
import MainSnackbar from "../../Utils/Snackbar/SmsSnackbar";
import {faClipboardList} from "@fortawesome/free-solid-svg-icons/faClipboardList";
import {BackButton, DataExportButton} from "../../Utils/Buttons/DataExportationButton";
import {useExcelReports} from "../../Utils/ReusableComponents/useExcelExport";
import { DateTimeFilter } from "../../Utils/ReusableComponents/DateTimeFilter";
import {useDebounce} from "../../Lab/useDebounce";
import axios from "axios";
import {config} from "../../../Helpers/env";
import { logoutErrorMessage} from "../../../Helpers/ErrorMessages";
import {CustomTableCell, MuiPaper, StickyHeadTable} from "../../Utils/Tables/StickyHeaderTable";
import {LoadingGif} from "../../Utils/Loader";
import Grid from "@material-ui/core/Grid";
import Label from "../../Utils/FormInputs/Label";
import Form from 'react-bootstrap/Form';
import { CustomSelect } from "../../Utils/FormInputs/SelectInput";
import {formatNumbers } from "../../Utils/formatNumbers";



const headData = [
    {id: 'count', numeric: false, disablePadding: false, label: 'SN.'},
    {id: 'product_name', numeric: false, disablePadding: false, label: 'Product'},
    {id: 'strength', numeric: false, disablePadding: false, label: 'Strength'},
    {id: 'batch_id', numeric: false, disablePadding: false, label: 'Batch#'},
    {id: 'expiry_date', numeric: false, disablePadding: false, label: 'Expiry Date'},
    {id: 'quantity_in', numeric: false, disablePadding: false, label: 'Qty In'},
    {id: 'quantity_out', numeric: false, disablePadding: false, label: 'Qty Out'},
    {id: 'current_stock', numeric: false, disablePadding: false, label: 'Current Stock'},
    {id: 'cost_price', numeric: false, disablePadding: false, label: 'Cost Price'},
    {id: 'stock_value', numeric: false, disablePadding: false, label: 'Stock Value'},
];



const StockBatchWiseReport = ({actions, snackbars}) => {
    const [date, setDate] = useState({start_date: '', end_date: ''});
    const [searchValue, setSearchValue] = useState('');
    const [store, setStore] = useState({value:'pharmacy', label:'Pharmacy'});
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [data, setData] = useState({stockItems: [], loading: 'idle', total: 0, summary: {}});
    const [activePage, setActivePage] = useState(1);
    const [debouncedInputValue] = useDebounce(searchValue, 500);

    const {start_date, end_date} = date;
    const {loading, total, stockItems, summary} = data;

    useEffect(() => {
        setData({...data, loading: 'pending'});
        
        const params = {
            store: store.value,
            page: activePage,
            per_page: rowsPerPage,
            ...(debouncedInputValue && {search: debouncedInputValue}),
            ...(start_date && {start_date: start_date}),
            ...(end_date && {end_date: end_date})
        };

        axios.get(`${config.smsUrl}/cinventory/stock_batchwise_report`, {params}).then(res => {
            const response = res.data;
            if (response.success) {
                const items = response.data || [];
                const pagination = response.pagination || {};
                const summaryData = response.summary || {};
                
                setData({
                    stockItems: items,
                    loading: 'success',
                    total: pagination.total_records || 0,
                    summary: summaryData
                });
            } else {
                throw new Error(response.error || 'Failed to fetch data');
            }
        }).catch((err) => {
            setData({...data, loading: 'error'});
            logoutErrorMessage(err, null, actions);
        });
    }, [debouncedInputValue, activePage, rowsPerPage, start_date, end_date, store.value]);

    const handleChangeDate = (event) => {
        const {value, name} = event.target;
        setDate({...date, [name]: value});
    };

    const handleStoreChange = (value) => {
        setStore(value);
        setActivePage(1);
        setPage(0);
    };

    const handleSearch = (event) => {
        setSearchValue(event.target.value);
    };
    
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        setActivePage(newPage + 1);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        setActivePage(1);
    };

    const closeSnackbar = () => {
        actions.snackbarActions.hideSnackbar();
    };

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2
        }).format(amount);
    };

    const isLoading = loading === 'pending';
    const isSuccess = loading === 'success';
    const isError = loading === 'error';

    const {openBar, type, message} = snackbars;

    const pagination = (
        <CustomTablePagination
            colSpan={3}
            activePage={activePage}
            page={page}
            rowsPerPage={rowsPerPage}
            count={total}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            isTotalCount
        />
    );

    const search_bar = (
        <EnhancedSearchTableToolbar
            term={searchValue} 
            handler={handleSearch}
            placeholder="Search by batch ID or product name..."
        />
    );
    
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, stockItems.length - page * rowsPerPage);

    const {exportExcel, isLoading: isLoadingExcel} = useExcelReports(actions, {
        file_name: `Stock Batchwise Report - ${store}`,
        url: `cinventory/stock_batchwise_report`,
        params: {
            download: true,
            store: store.value,
            ...(start_date && {start_date}),
            ...(end_date && {end_date}),
            ...(searchValue && {search: searchValue})
        }
    });

    return (
        <div className='journals' data-testid="stock-batchwise-report">
            <PageTitle title="Stock Batch-wise Report"/>
            <SubHeader title="Reports" subTitle="Stock Batch-wise Report">
                <FontAwesomeIcon icon={faClipboardList}/>
            </SubHeader>
            
            <div style={{display:'flex', justifyContent:'space-between', flexWrap:'wrap'}}>
                <div style={{margin: '10px'}}>
                    <BackButton text={'General Reports'} to={'/reports/generalreports'}/>
                </div>
                <div style={{margin: '10px'}}>
                    <DataExportButton exportCsv={exportExcel} isLoading={isLoadingExcel}/>
                </div>
            </div>

            <div className="mui-tables mt-2">
                {/* Store Filter */}
                <Grid container spacing={2} style={{marginBottom: '16px'}}>
                    <Grid item xs={12} sm={6} md={3}>
                        <Form.Group fullWidth variant="outlined">
                            <Label name="Store"/>
                            <CustomSelect
                                name="store"
                                value={store}
                                onChange={handleStoreChange}
                                data_testid="store-select"
                                options={[
                                    {label: 'Pharmacy', value: 'pharmacy'},
                                    {label: 'Store', value: 'store'},
                                    {label: 'Lab', value: 'lab'}
                                ]}
                                defaultValue={{label: 'Select Store...', value: ''}}
                            />
                        </Form.Group>
                    </Grid>
                </Grid>

                {/* Date Filter */}
                <DateTimeFilter
                    {...{
                        start_date,
                        end_date,
                        type: "date",
                        isFilter: false,
                        handleChange: handleChangeDate
                    }}
                />

                {/* Summary Info */}
                {isSuccess && summary && (
                    <div style={{
                        background: '#f5f5f5',
                        padding: '12px',
                        marginBottom: '16px',
                        borderRadius: '4px',
                        border: '1px solid #ddd'
                    }}>
                        <strong>Summary: </strong> 
                        {/* Total Batches: {summary.total_batches || 0} |  */}
                        Total Stock Value: <strong>${formatNumbers(summary.total_stock_value || 0)}</strong> | 
                        Store: <strong>{summary.store || store.charAt(0).toUpperCase() + store.slice(1)}</strong>
                    </div>
                )}

                <MainSnackbar variant={type} open={openBar} message={message} handleCloseBar={closeSnackbar}/>
                <MuiPaper>
                    {search_bar}
                    <StickyHeadTable {...{width:'100%', data:stockItems, columns:headData.filter(item=>Boolean(item)), pagination}}>
                        {isLoading ? <TableRow><TableCell align='center' {...{colSpan:headData.length}}><LoadingGif/></TableCell></TableRow>:null}
                        {isSuccess ? stockItems.length > 0 ?
                            <>
                                {stockItems.slice(0, rowsPerPage).map((row, index) => {
                                    const count = ((activePage - 1) * rowsPerPage) + index + 1;
                                    return (
                                        <TableRow tabIndex={-1} key={index}>
                                            {headData.map(col=>(
                                                col.id === 'count' ? 
                                                    <CustomTableCell key={col.id}>{count}</CustomTableCell> :
                                                col.id === 'cost_price' || col.id === 'stock_value' ?
                                                    <CustomTableCell key={col.id} align="right">${formatNumbers(row[col.id] || 0)}</CustomTableCell> :
                                                col.id === 'quantity_in' || col.id === 'quantity_out' || col.id === 'current_stock' ?
                                                    <CustomTableCell key={col.id} align="right">{(row[col.id] || 0).toLocaleString()}</CustomTableCell> :
                                                    <CustomTableCell key={col.id}>{row[col.id] || 'N/A'}</CustomTableCell>
                                            ))}
                                        </TableRow>
                                    );
                                })}
                                {emptyRows > 0 && (
                                    <TableRow style={{ height: 5 }}>
                                        <TableCell colSpan={headData.length} />
                                    </TableRow>
                                )}
                            </>:<TableRow><TableCell align='center' {...{colSpan:headData.length}}>No records found</TableCell></TableRow>:null}
                        {isError ? <TableRow><TableCell align='center' {...{colSpan:headData.length}}>The server did not return a valid response</TableCell></TableRow>:null}
                    </StickyHeadTable>
                </MuiPaper>
            </div>
        </div>
    )
};

function mapStateToProps(state) {
    return {snackbars: state.snackbar}
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            snackbarActions: bindActionCreators(snackbarActions, dispatch)
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(StockBatchWiseReport);
